import React from 'react';
import {i18n} from '@netx/core/i18n';
import {faPlusCircle} from '@fortawesome/pro-regular-svg-icons';
import {
	IconButtonToggle,
	type IconButtonToggleProps,
} from '@netx/core-components/IconButtonToggle';

export interface AppendToggleProps
	extends Omit<IconButtonToggleProps, 'confirm' | 'icon' | 'label'> {
	confirm?: boolean;
}

export const AppendTogglePrimitive = ({
	confirm,
	disabled,
	...props
}: AppendToggleProps) => {
	return (
		<IconButtonToggle
			aria-label="toggle append mode"
			{...props}
			confirm={
				confirm
					? {
							title: i18n.t('i18n.toggleAppendModeConfirmTitle'),
							message: i18n.t('i18n.toggleAppendModeConfirmMessage'),
					  }
					: undefined
			}
			disabled={disabled}
			icon={faPlusCircle}
			label={
				disabled
					? ''
					: props.on
					? i18n.t('i18n.disableAppendMode')
					: i18n.t('i18n.enableAppendMode')
			}
		/>
	);
};

export const AppendToggle = React.memo(AppendTogglePrimitive);

export default AppendToggle;
